import React, { useMemo } from "react";

import { Transaction } from "@codemirror/state";
import CodeMirror from "@uiw/react-codemirror";

function CodeMirrorEditorHost({
    editorRef,
    value,
    sessionKey,
    extensions,
    basicSetup,
    className,
    style,
    height = "100%",
    isRealtime = false,
    onChange,
    onUpdate,
    onCreateEditor,
}) {
    const initialRealtimeValue = useMemo(() => value, [sessionKey]);

    return (
        <div style={{ height }}>
            <CodeMirror
                key={sessionKey}
                ref={editorRef}
                className={className}
                style={style || { height }}
                value={isRealtime ? initialRealtimeValue : value}
                height={height}
                extensions={extensions}
                basicSetup={basicSetup}
                onCreateEditor={(view) => onCreateEditor?.({ view, sessionKey })}
                onUpdate={onUpdate}
                onChange={(nextValue, viewUpdate) => {
                    if (viewUpdate.transactions.some((transaction) => transaction.annotation(Transaction.remote))) {
                        return;
                    }
                    onChange?.(nextValue, viewUpdate.state.selection.main.head, viewUpdate);
                }}
            />
        </div>
    );
}

export default CodeMirrorEditorHost;
